import { API_SET_APPLICATION_DATA } from "../actions"

const defaultState = {}

export function application(state = defaultState, action) {
  return action.type === API_SET_APPLICATION_DATA ? action.payload : state
}
